import {createReducer, isAnyOf} from '@reduxjs/toolkit'
import {getOrder} from '../actions/placed-order'
import {SEND_RSVP_OLD, sendRsvp} from '../actions/rsvp'

export const calendarLinks = createReducer(null, builder => {
  builder.addMatcher(
    action => action.type === SEND_RSVP_OLD.SUCCESS || isAnyOf(sendRsvp.fulfilled, getOrder.fulfilled)(action),
    (_, action) => {
      return {
        ...action.payload.calendarLinks,
      }
    },
  )
})
